exports.setAttachments = (files) => {
    const arr = Array.from(files);
    const newFiles = [];
    // Loop through array
    arr.forEach(file => {
        if (file.type.indexOf('image/') === -1) {
            return false;
        }
        if (typeof FileReader === 'function') {
            const reader = new FileReader();
            reader.onload = (event) => {
                newFiles.push(event.target.result);
            };
            reader.readAsDataURL(file);
        } else {
            return false;
        }
    });
    return newFiles;
}
exports.DataURIToBlob = (dataURI) => {
    const splitDataURI = dataURI.split(',')
    const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
    const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

    const ia = new Uint8Array(byteString.length)
    for (let i = 0; i < byteString.length; i++)
        ia[i] = byteString.charCodeAt(i)

    return new Blob([ia], { type: mimeString })
}
